import { Close as CloseIcon, Delete, Filter1Rounded, Search, Sort } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Tab,
  Button,
  FormControl,
  FilledInput,
  InputAdornment,
  ButtonGroup,
  Collapse,
  InputLabel,
  MenuItem,
  Select,
  Tabs,
  Paper,
  Grid,
  Badge,
  IconButton,
  Popover,
  MenuList,
  ListItemText,
  ListItemIcon,
  Skeleton,
  TextField,
} from "@mui/material";

import {
  getallaclusers,
  getalluser,
  resendemail,
  resetUsers,
  resetActualUsers,
} from "../../actions/user";
import { ApplyStyle as _s } from "../../utils/ApplyStyle";

import React, { useEffect, useMemo, useState } from "react";
import { ReactComponent as Filter } from "../../assets/filter.svg";

import { ReactComponent as TableMode } from "../../assets/TableViewSvg.svg";
import { ReactComponent as TileMode } from "../../assets/TileViewSvg.svg";

import UsersTable from "./UsersTable";

import { ReactComponent as EllipseSvg } from "../../assets/EllipseSvg.svg";
import { ReactComponent as EllipseGraySvg } from "../../assets/EllipseGraySvg.svg";

import { Link, useLocation, useNavigate } from "react-router-dom";
import TabPanel from "../../components/TabPanel";
import ScopeHeader from "../../components/ScopeHeader";
import { connect } from "react-redux";
import AdminTypos from "./AdminTypos";
import AdminFaq from "./AdminFaq";
import moment from "moment";
import { canUserPerformAction } from "../../shared-functions/userrights";
import { getItem } from "../../utils/DataProtection";
import { withCurrentAccountPrefix } from "../../utils/accountMode";
import { Theme247 } from "../../styles/Theme247";

export default connect(
  ({ isadmin, users, i18n, userProfile, aclusers, profile, profiles, profileid, lang }) => ({
    isadmin,
    users,
    i18n,
    userProfile,
    aclusers,
    profiles,
    profile,
    profileid,
    lang
  }),
  { getalluser, getallaclusers, resendemail, resetUsers, resetActualUsers }
)((props) => {
  const i18n = props.i18n;
  const currentUserId = JSON.parse(getItem("userid"));
  const aclusers = useMemo(() => {
    return props.aclusers?.length
      ? props.aclusers.map((acl) => ({
        ...acl,
        isCurrentUser: acl.user.userid === currentUserId,
      }))
      : [];
  }, [props.aclusers, currentUserId]);
  const lang = props.lang;
  const profiles = props.profiles;


  const t = [];
  const [_users, set_users] = useState(t);
  const [isUsersLoading, setIsUsersLoading] = useState(true);

  const navigate = useNavigate();

  const users = props.users;
  const [host, setHost] = useState("");
  const [port, setPort] = useState("");
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");


  const [data, setData] = useState(users);


  const refreshList = () => {
    setIsUsersLoading(true);

    setTimeout(() => {
      props.getalluser();
      props.getallaclusers("ACL_USERS");
    }, [2000]);
  }

  useEffect(() => {
    set_users([])
    refreshList();
  }, []);

  useEffect(() => {
    if (Array.isArray(props.users) && Array.isArray(props.aclusers)) {
      setIsUsersLoading(false);
    }
  }, [props.users, props.aclusers]);


  const location = useLocation();

  const [statusValue, setStatusValue] = useState("");

  const [appBarValue, setAppBarValue] = React.useState(location.state ? location.state.activeTab : 0);
  const [userStatus, setuserStatus] = React.useState("alle");
  const [userType, setuserType] = React.useState("");
  const [showFilter, setShowFilter] = useState(false);

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  const handleAppBarChange = (
    event,
    newValue
  ) => {
    setAppBarValue(newValue);
  };

  const [viewMode, setViewMode] = useState("table");

  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);

  let searchEnabled = searchText.length;

  const handleSearch = (e) => {
    let text = e.target.value.toLowerCase();
    setSearchText(text);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleStatusChange = (event) => {
    setuserStatus(event.target.value);
  };

  const handleChangeUserType = (event) => {
    setuserType(event.target.value);
  };

  const handleUpdateEmailConfig = async () => {
    // const paylod = {
    //   clientid: clientId,
    //   clientinfo: {
    //     autoemailconfig: {
    //       host: host,
    //       port: port,
    //       username: username,
    //       password: password,
    //     },
    //   },
    // };



    // const promises = [updateEmailConfig(paylod)]; // Ensure that promises is an array

    // if (isAuthUser === true) {
    //   try {
    //     const result = await Promise.all(promises);
    //     a11yProps(0);
    //     setAppBarValue(0);
    //   } catch (error) {
    //     console.error("Error during Promise.all:", error);
    //     // Handle the error appropriately
    //   }
    // }
  };



  useEffect(() => {
    if (Array.isArray(users) && users.length && aclusers.length) {
      const temp2 = [];

      for (const usr of users) {
        let usertype = aclusers.length
          ? aclusers.filter(
            (user) => user.user.usernodeid === usr.user.nodeid
          )[0]?.user.userinfo.profileid
          : undefined;



        let userid = aclusers.length
          ? aclusers.filter(
            (user) => user.user.usernodeid === usr.user.nodeid
          )[0]?.user.userid : "";

        if (usertype !== undefined) {
          temp2.push({
            ...usr,
            userType: usertype,
            userid: userid,
            isCurrentUser: userid === JSON.parse(getItem("userid"))
          });
        }
      }

      set_users(temp2);
    }
  }, [users, aclusers]);

  useEffect(() => {
    if (Array.isArray(users)) {
      setData([]);
      let data = _users;

      if (searchEnabled) {
        if (searchText.length) {
          setPage(0);
          data = data.filter((row) => {
            return (
              row.user.givenname.toLowerCase().includes(searchText) ||
              row.user.surname.toLowerCase()?.includes(searchText) ||
              row.user.email.toLowerCase()?.includes(searchText)
            );
          });
        }
      }

      if (userStatus !== "alle") {
        data = data.filter((data) => {
          return data.user.active === Boolean(userStatus);
        });
      }

      if (userType !== "") {
        //console.log(data, "userTypeuserType");
        data = data.filter((data) => {
          return data.userType === userType;
        });
      }

      setData(data);
    }
  }, [searchText, userStatus, userType, _users]);

  useEffect(() => {
    if (!showFilter) {
      setStatusValue("alle");
      setuserType("");
    }
  }, [showFilter]);

  const getQuotaDuration = (quota) => {
    switch (quota[quota.length - 1]) {  // reading last character
      case "y":
      case "Y":
        return i18n.year;
      case "m":
      case "M":
        return i18n.month;
      case "d":
      case "D":
        return i18n.days;
      default:
        return ""
    }
  }


  const plans = JSON.parse(getItem("plans"));
  const usersPlans = JSON.parse(getItem("plans")).length ? JSON.parse(getItem("plans"))[0]?.quotas?.filter((plan) => plan.type === "USERS") : [];


  const billingInfo = JSON.parse(getItem("billinginfo"));

  const toAddInExpiry = plans?.length ? (plans[0].quotas[0]?.quota[plans[0].quotas[0]?.quota.length - 1] === "m" ? "M" : plans[0].quotas[0]?.quota[plans[0].quotas[0]?.quota.length - 1]) : "";

  const x = plans?.length ? getQuotaDuration(plans[0].quotas[0]?.quota) : "";

  const UsersTabSkeleton = () => (
    <div className="_content" style={{ marginBottom: "23%" }}>
      <div className="header">
        <div
          className="_title"
          style={{ width: "35%", display: "flex", alignItems: "center", gap: 20 }}
        >
          <Skeleton variant="text" width={170} height={48} />
          <Skeleton variant="rounded" width={120} height={44} />
        </div>

        <div className="_users_list" style={{ width: "35%" }}>
          <Skeleton variant="rounded" width="100%" height={56} />
        </div>

        <div style={{ width: "23%", display: "flex", justifyContent: "end", gap: 16 }}>
          <Skeleton variant="rounded" width={104} height={40} />
          <Skeleton variant="rounded" width={48} height={40} />
        </div>
      </div>

      <div style={{ background: "#FFFFFF", marginTop: "3%", borderRadius: 4 }}>
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} style={{ padding: "18px 24px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "0.7fr 1.1fr 1.1fr 1fr 1.3fr 0.5fr", gap: 16, alignItems: "center" }}>
              <Skeleton variant="text" width={44} height={28} />
              <Skeleton variant="text" width="80%" height={28} />
              <Skeleton variant="text" width="80%" height={28} />
              <Skeleton variant="text" width="70%" height={28} />
              <Skeleton variant="text" width="90%" height={28} />
              <Skeleton variant="circular" width={24} height={24} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const usersCountTitleStyle = {
    fontSize: "20px",
    letterSpacing: "0.15px",
    lineHeight: "140%",
    fontWeight: 600,
    fontFamily: "Bai Jamjuree",
    color: "var(--color-primary)",
    textAlign: "left",
  };


  return (
    <div className="admin_dashboard">
      <ScopeHeader
        bgColor="var(--color-primary)"
        bgImage="../images/bg1.webp"
        txtColor="#FFFFFF"
        title={i18n.admin_scope_header_0}
        description={i18n.admin_scope_header_desc_0}
      />

      <Box
        className={_s(Theme247.tabsContainer)}>
        <AppBar
          className="appBar"
          position="static"
          variant="elevation"
          sx={
            {
              borderTopRightRadius: "4px",
              borderTopLeftRadius: "4px",

            }
          }
        >
          <Tabs
            value={appBarValue}

            onChange={(e, v) => handleAppBarChange(e, v)}
            indicatorColor="secondary"
            textColor="inherit"
            aria-label="full width tabs example"

          >
            {/* <Tab className="tab" label="Ihr Abo" {...a11yProps(0)} disabled /> */}
            <Tab className="tab" label={i18n.users.tabSubscription} {...a11yProps(0)} style={{ padding: "0px 37px", margin: "0px", borderTopLeftRadius: "4px" }} />
            <Tab className="tab" id="btn_admin_tab_users" data-testid="btn_admin_tab_users" label={i18n.users.tabUsers} {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <Box
          sx={{
            width: "100%",
            height: "1px",
            position: "relative",
            backgroundColor: "rgba(0, 0, 0, 0.12)",
          }}
        />

        <TabPanel value={appBarValue} index={0} style={{
          marginBottom: "8%"
        }} >
          <div className="_content" style={{ padding: "2%" }}>
            <div className="abo-admin bxShadow" style={{ padding: "2%" }}>
              <div className="title">{i18n.users.subscriptionSummaryTitle}</div>
              <div className="content">
                <div className="col1">
                  <AdminTypos primary={i18n.users.currentPlan} secondary={plans.length && plans[0].name} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={i18n.users.term} secondary={plans.length && plans[0].quotas ? ("" + plans[0].quotas[0]?.quota.match(/-?\d+\.?\d*/)[0] + " " + getQuotaDuration(plans[0].quotas[0]?.quota)) : ""} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={i18n.users.subscribedOn} secondary={plans.length && plans[0].quotas ? moment(plans.length && plans[0].quotas[0]?.startingfrom).format("DD.MM.YYYY") : ""} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={i18n.users.autoRenewal} secondary={"Am " + plans[0].quotas ? moment(plans.length && plans[0].quotas[0]?.startingfrom).add(plans.length && plans[0].quotas[0]?.quota.match(/-?\d+\.?\d*/)[0], toAddInExpiry).format("DD.MM.YYYY") : ""} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={i18n.users.noticePeriod} secondary={plans.length && plans[0].quotas ? (plans.length && plans[0].quotas[0]?.noticeperiod && plans.length && plans[0].quotas[0]?.noticeperiod.replace("m", " Monat") + " zur Verlängerung") : ""} style={{ borderBottom: "1px solid lightgray" }} />

                </div>
                <div className="col2">
                  <AdminTypos primary={i18n.users.organizationName} secondary={props.userProfile?.user?.ismemberof &&
                    props.userProfile?.user?.ismemberof[0]?.legalentity
                      .name} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={i18n.users.userLimit} secondary={usersPlans[0]?.quota ? (usersPlans[0]?.quota + " (derzeit " + _users.length + " genutzt)") : ""} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={i18n.users.subscription} secondary={billingInfo.subscriptionid ? billingInfo.subscriptionid : ""} style={{ borderBottom: "1px solid lightgray" }} />

                </div>
              </div>
            </div>

            <div className="abo-admin bxShadow" style={{ padding: "2%", margin: "3% 0%" }}>
              <div className="title">{i18n.users.billingTitle}</div>
              <div className=" box-2">
                <div className="title1">{i18n.users.billingTitle}</div>
                <div className="title2">
                  {billingInfo.billingname} {"\n"}
                  {billingInfo.billingstreet} {billingInfo.billingstreetnumber}  {"\n"}
                  {billingInfo.billingzipcode} {billingInfo.billingcity}  {"\n"}
                  {billingInfo.billingcountry}
                </div>
                <div className="admin-typos-2">
                  <AdminTypos primary={i18n.users.billingShipping} secondary={i18n.users.billingElectronic} style={{ borderBottom: "1px solid lightgray" }} />
                  <AdminTypos primary={i18n.users.shipTo} secondary={`${billingInfo?.billingbillingemail ? billingInfo?.billingbillingemail : ""}`} />
                </div>
              </div>
            </div>


            <div className="admin-smallDesc">{i18n.users.contactSupport}</div>

            <div className="admin-footer">
              <div className="faq">
                <div className="_title">{i18n.users.faqTitle}</div>
                <div className="_answer"><AdminFaq data={[{
                  question: i18n.users.faqQ1,
                  answer: `<div>${i18n.users.faqA1}</div>`
                },
                { question: i18n.users.faqQ2, answer: i18n.users.faqA2 },
                { question: i18n.users.faqQ3, answer: i18n.users.faqA3 },
                { question: i18n.users.faqQ4, answer: i18n.users.faqA4 },
                { question: i18n.users.faqQ5, answer: `<div>${i18n.users.faqA5}</div>` }]} /></div>
              </div>

              <div className="admin-customer">
                <div className="_title">{i18n.users.customerServiceTitle}</div>
                <div className="avatarWrapper">
                  <div className="avatar"><div className="bxShadow" /></div>
                  <div className="avatarContent">
                    <div className="_name">{i18n.help.supportPerson}</div>
                    {/* <div className="_phone"> <a href="tel:+49 (0)8158 9239817">+49 (0)8158 9239817</a></div> */}
                    <div className="_email"> <a href="mailto:support@247factorynet.com">support@247factorynet.com</a></div>
                    <div className="_timing">{i18n.help.supportHours}</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </TabPanel>

        <TabPanel value={appBarValue} index={1} style={{
          marginBottom: "8%"
        }}>
          <div className="_content" style={{ marginBottom: "23%" }}>
            <div className="header">
              <div
                className="_title"
                style={{ width: "35%", display: "flex", alignItems: "center" }}
              >
                <div style={usersCountTitleStyle}>
                  {i18n.users.tabUsers} ({data.length})
                </div>

                {canUserPerformAction(
                  props.profile?.features?.user,
                  "create"
                ) && (

                    <div className="_button">
                      <Link to={withCurrentAccountPrefix("/add-user")} state={{ padeType: "add" }}>
                        <Button
                          variant="contained"
                          sx={{ marginLeft: "20px", letterSpacing: "1.25px" }}
                          id="btn_users_add"
                          data-testid="btn_users_add"
                        >
                          {i18n.users.addNew}
                        </Button>
                      </Link>
                    </div>)}
              </div>

              <div className="_users_list" style={{ width: "35%" }}>
                {" "}
                <div>
                  <FormControl fullWidth variant="filled">
                    <FilledInput
                      sx={{ background: "#FFFFFF !important", padding: 0 }}
                      id="filled-adornment-weight"
                      placeholder={i18n.users.searchPlaceholder}
                      value={searchText}
                      onChange={handleSearch}
                      endAdornment={
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      }
                      aria-describedby="filled-weight-helper-text"
                      inputProps={{
                        "aria-label": "weight",
                        "data-testid": "txtf_users_search",
                        "id": "txtf_users_search"
                      }}
                    />
                  </FormControl>
                </div>
              </div>
              <div
                style={{ width: "23%", display: "flex", justifyContent: "end" }}
              >
                <div className="_filterBtn" style={{ paddingRight: "10%" }}>
                  <Button
                    variant={showFilter ? "outlined" : "text"}
                    startIcon={showFilter ? <CloseIcon fontSize="small" /> : <Filter />}
                    sx={{
                      minWidth: 112,
                      height: 40,
                      px: 1.5,
                      borderColor: showFilter ? "rgba(0, 0, 0, 0.16)" : "transparent",
                      color: "var(--color-primary)",
                      "& .MuiButton-startIcon": {
                        marginRight: "8px",
                        marginLeft: 0,
                        display: "inline-flex",
                        alignItems: "center",
                      },
                      "& .MuiButton-startIcon svg": {
                        color: showFilter ? "rgba(0, 0, 0, 0.5)" : "inherit",
                      },
                      "& .MuiButton-startIcon svg": {
                        display: "block",
                      },
                      "&:hover": {
                        borderColor: showFilter
                          ? "rgba(var(--color-primary-rgb), 0.42)"
                          : "rgba(var(--color-primary-rgb), 0.28)",
                        backgroundColor: "transparent",
                      },
                    }}
                    onClick={() => {
                      setShowFilter(!showFilter);
                    }}
                    data-testid="btn_users_filter_view"
                  >
                    {i18n.users.filterButton}
                  </Button>
                </div>
                <div className="_buttonGroup">
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Basic button group"
                    sx={{ height: "36px" }}
                  >
                    <Button
                      sx={{ width: "36px" }}
                      startIcon={
                        <TableMode
                          color={viewMode === "table" ? "#FFFFFF" : "#000000"}
                        />
                      }
                      onClick={() => setViewMode("table")}
                      variant={viewMode === "table" ? "contained" : "outlined"}
                    ></Button>

                  </ButtonGroup>
                </div>
              </div>
            </div>

            <Box
              sx={{ height: "auto", backgroundColor: "#2121210D" }}
              style={{ marginTop: showFilter ? "3%" : "0%" }}
            >
              <Box
                sx={{
                  "& > :not(style)": {
                    display: "flex",
                    justifyContent: "space-around",
                    height: "auto",
                    width: "100%",
                  },
                }}
              >
                <div>
                  <Collapse in={showFilter} sx={{ width: "100%" }}>
                    <div className="history-filters" style={{ background: "transparent" }}>
                      <div className="row1">
                        <div className="child">
                          <FormControl
                            variant="standard"
                            sx={{ margin: 0 }}
                            fullWidth
                          >
                            <InputLabel id={"filter_type"}>
                              {i18n.users.filterAccountStatus}
                            </InputLabel>
                            <Select
                              labelId={"filter_type"}
                              id={"filter_type"}
                              data-testid="drpdwn_users_status_filter"
                              label={i18n.users.filterButton}
                              value={userStatus}
                              onChange={handleStatusChange}
                            >
                              <MenuItem value="alle" data-testid="drpdwn_users_status_filter_li">
                                <em>{i18n.users.statusAll}</em>
                              </MenuItem>
                              {[
                                {
                                  name: i18n.users.statusActive,
                                  value: 1,
                                },
                                {
                                  name: i18n.users.statusInactive,
                                  value: 0,
                                },
                              ].map((noti, key) => {
                                return (
                                  <MenuItem value={noti.value} key={key} data-testid="drpdwn_users_status_filter_li">
                                    {noti.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="child">
                          <FormControl
                            variant="standard"
                            sx={{ margin: 0 }}
                            fullWidth
                          >
                            <InputLabel id={"filter_status"}>
                              {i18n.users.filterUserType}
                            </InputLabel>
                            <Select
                              id={"filter_status"}
                              label={i18n.users.filterButton}
                              value={userType}
                              onChange={handleChangeUserType}
                              data-testid="drpdwn_users_type_filter"
                            >
                              {profiles &&
                                profiles?.map((profile) => {
                                  return (
                                    <MenuItem value={profile.id}>
                                      {profile?.name.de}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              </Box>
            </Box>

            {isUsersLoading ? (
              <UsersTabSkeleton />
            ) : (
              <UsersTable
                data={data}
                handlePageChange={handleChangePage}
                searchText={searchText}
                page={page}
                refreshList={refreshList}
                setPage={setPage}
                viewMode={viewMode}
                profiles={props.profiles}
                profile={props.profile}
              />
            )}
          </div>
        </TabPanel>
      </Box>
    </div>
  );
})
